import {
  ADD_REWARD,
  ADD_REWARDTYPE,
  DELETE_REWARD,
  GET_REWARDTYPE,
  GET_REWARD_BY_ADDMIN,
  GET_REWARD_BY_CLASS,
  GET_REWARD_BY_STUDENT,
  GET_STUDENT_REWARD_BY_CLASS,
  ROOT,
  UPDATE_REWARD,
  UPDATE_REWARDTYPE,
} from './constant'
import { handleResponse } from './handle-response'
import { requestOptions } from './request-options'

function getRewardTypeList() {
  return fetch(ROOT + GET_REWARDTYPE, requestOptions.get())
    .then(handleResponse)
    .then(res => {
      return res
    })
}
function getRewardByStudent(studentID) {
  return fetch(ROOT + GET_REWARD_BY_STUDENT + `studentID=${studentID}`, requestOptions.get())
    .then(handleResponse)
    .then(res => {
      return res
    })
}

function getRewardByClass(locationID, classStatusID, fromDate, toDate) {
  return fetch(
    ROOT +
      GET_REWARD_BY_CLASS +
      `locationId=${locationID}&classStatusID=${classStatusID}&fromDate=${fromDate}&toDate=${toDate}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(res => {
      return res
    })
}
function getStudentRewardByClass(classID, rewardTypeID) {
  return fetch(
    ROOT + GET_STUDENT_REWARD_BY_CLASS + `classID=${classID}&rewardTypeID=${rewardTypeID}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(res => {
      return res
    })
}

function getRewardList(locationID, classStatusID, fromMonth, toMonth) {
  return fetch(
    ROOT +
      GET_REWARD_BY_ADDMIN +
      `locationId=${locationID}&classStatusID=${classStatusID}&fromMonth=${fromMonth}&toMonth=${toMonth}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(res => {
      return res
    })
}
function addReward(data) {
  return fetch(ROOT + ADD_REWARD, requestOptions.postBody(data))
    .then(handleResponse)
    .then(res => {
      return res
    })
}
function addRewardType(data) {
  return fetch(ROOT + ADD_REWARDTYPE, requestOptions.postBody(data))
    .then(handleResponse)
    .then(res => {
      return res
    })
}
function updateReward(data) {
  return fetch(ROOT + UPDATE_REWARD, requestOptions.put(data))
    .then(handleResponse)
    .then(res => {
      return res
    })
}
function updateRewardType(data) {
  return fetch(ROOT + UPDATE_REWARDTYPE, requestOptions.put(data))
    .then(handleResponse)
    .then(res => {
      return res
    })
}
function deleteReward(rewardID) {
  return fetch(ROOT + DELETE_REWARD + `rewardID=${rewardID}`, requestOptions.delete())
    .then(handleResponse)
    .then(res => {
      return res
    })
}
export const rewardApi = {
  getRewardTypeList,
  addReward,
  getRewardList,
  deleteReward,
  getRewardByStudent,
  updateReward,
  addRewardType,
  updateRewardType,
  getStudentRewardByClass,
  getRewardByClass,
}
